import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import RadioButton from "@ingka/radio-button";
import cx from "classnames";
const RadioButtonGroup = (props) => {
  const {
    className,
    list,
    name,
    prefix = "",
    subtle = false,
    ...other
  } = props;
  const classes = cx(`${prefix}radio-button-group`, className);
  return /* @__PURE__ */ jsxs("fieldset", { role: "radiogroup", className: classes, ...other, children: [
    name && /* @__PURE__ */ jsx("legend", { children: name }),
    list.map((item, i) => {
      const { key, ...itemProps } = item;
      return /* @__PURE__ */ createElement(
        RadioButton,
        {
          ...itemProps,
          key: key ?? i,
          prefix,
          subtle
        }
      );
    })
  ] });
};
var RadioButtonGroup_default = RadioButtonGroup;
export {
  RadioButtonGroup_default as default
};
